/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint func-names: ["error", "never"] */

export const state = {
  loading: false,
  pageOptions: {},
};

export const mutations = {
  'featuredVideos/LOADING': function (state) {
    state.loading = true;
  },
  'featuredVideos/LOADED': function (state, resp) {
    // console.log('store.videos.loaded', resp.data);
    state.loading = false;
    state.filter.searchCount = resp.data.count;
  },
  'featuredVideos/FILTER': function (data, filter) {
    console.log('store.videos.filter', data, filter);
    // this.dispatch('updateSearchText', filter);
  },
  'featuredVideos/PAGINATION': function (state, data) {
    console.log('store.adminMembers.pagination', data);
    // window.history.replaceState(null, null, `${window.location.pathname}?page=${data}`);
    // this.state.loading = true;
  },
};

export const actions = {};
